var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemSmall2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1553,
    viewBox: "0 0 1440 2853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-62.2909 882.23C-65.2509 1000.31 12.1813 1095.52 139.955 1153.94C267.719 1212.35 445.736 1233.94 643.722 1204.83C841.709 1175.71 1022.13 1101.41 1153.78 1004.84C1285.44 908.271 1368.23 789.5 1371.19 671.422C1374.15 553.343 1296.72 458.135 1168.95 399.715C1041.18 341.299 863.167 319.71 665.18 348.826C467.194 377.942 286.773 452.243 155.125 548.807C23.4653 645.38 -59.3309 764.151 -62.2909 882.23Z",
    stroke: "url(#paint0_linear_897_463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-387.15 930.005C-391.454 1101.68 -278.877 1240.06 -93.195 1324.95C92.4757 1409.85 351.163 1441.22 638.857 1398.91C926.551 1356.6 1188.73 1248.63 1380.05 1108.3C1571.38 967.96 1691.75 795.322 1696.05 623.649C1700.36 451.977 1587.78 313.596 1402.1 228.699C1216.43 143.807 957.739 112.439 670.046 154.747C382.352 197.055 120.171 305.022 -71.1452 445.354C-262.473 585.694 -382.847 758.332 -387.15 930.005Z",
    stroke: "url(#paint1_linear_897_463)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M777.419 1440.25C485.07 1470.98 222.382 1251.46 190.691 949.932C158.999 648.407 370.304 379.064 662.654 348.337C955.004 317.61 1217.69 537.134 1249.38 838.659C1281.07 1140.18 1069.77 1409.53 777.419 1440.25Z",
    fill: "url(#paint2_linear_897_463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_897_463",
    x1: 1331.55,
    y1: 629.117,
    x2: 7.59751,
    y2: 738.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_897_463",
    x1: 1638.22,
    y1: 562.217,
    x2: -285.383,
    y2: 720.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_897_463",
    x1: 1399.15,
    y1: 115.704,
    x2: 752.84,
    y2: 883.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "white",
    stopOpacity: 0.151042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61B1FB",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSmall2);
export default __webpack_public_path__ + "static/media/systemSmall2.5308a32f0a2771781e2e04e99e6c05ef.svg";
export { ForwardRef as ReactComponent };